var prodcat = prodcat || {};
var site = site || {};

prodcat.data = prodcat.data || {};

(function ($, prodcat) {
  Drupal.behaviors.productFullShadesV1 = {
    isMobile: false,
    nodes: {},
    attach: function (context) {
      var self = this;

      if (self.attached) {
        return;
      }
      self.attached = true;

      function sortShadesAndInventory() {
        var locale = (typeof generic !== 'undefined' && generic.cookie) ? generic.cookie('LOCALE') : '';
        var allowedLocales = ['pt_BR', 'es_MX', 'es_CL'];

        if (allowedLocales.includes(locale)) {
          var $container = jQuery('.js-spp-shades-grid, .size-select--chips-wrapper', context);

          $container.each(function() {
              var $this = jQuery(this);
              var $children = $this.children();

              $children.each(function(index) {
                  jQuery(this).attr('data-original-index', index);
              });

              $children.detach().sort(function (a, b) {
                  var $a = jQuery(a);
                  var $b = jQuery(b);

                  var getInventoryRank = function($el) {
                      var status = $el.attr('data-inventory-status');
                      if ($el.hasClass('shade-inv-status--2') || status == '2') {
                          return 1;
                      }
                      if ($el.hasClass('shade-inv-status--7') || status == '7') {
                          return 2;
                      }
                      return 0;
                  };

                  var rankA = getInventoryRank($a);
                  var rankB = getInventoryRank($b);

                  if (rankA !== rankB) {
                      return rankA - rankB;
                  }

                  var orderA = parseInt($a.attr('data-display-order'), 10);
                  var orderB = parseInt($b.attr('data-display-order'), 10);

                  if (isNaN(orderA)) orderA = parseInt($a.attr('data-original-index'), 10);
                  if (isNaN(orderB)) orderB = parseInt($b.attr('data-original-index'), 10);

                  return orderA - orderB;

              }).appendTo($this);
          });
        }
      }

      function sortDropdownAlphabetically() {
        var $shadeDDOptions = jQuery('.js-shade-select-options', context);

        if ($shadeDDOptions.length) {
          $shadeDDOptions.each(function() {
            var $this = jQuery(this);

            $this.children().detach().sort(function (a, b) {
              var nameA = (jQuery(a).attr('data-shade-name') || jQuery(a).text()).trim();
              var nameB = (jQuery(b).attr('data-shade-name') || jQuery(b).text()).trim();

              return nameA.localeCompare(nameB, undefined, { sensitivity: 'base', numeric: true });
            }).appendTo($this);
          });
        }
      }

      sortShadesAndInventory();
      sortDropdownAlphabetically();

      var $template = $('.js-product-full-shades', context);
      var $sppShades = $('.js-spp-shades', context);
      var $sppShadesGrid = $(
        '.js-product-full-shades-grid, .js-product-full--shades-grid',
        context
      );

      self.nodes.$shadeSwatches = $('.js-spp-shades-grid-item', $sppShadesGrid);
      var $product = $('.js-product-full', context);
      var $shadeOpenTab = $('.js-shade-select-wrapper', $product);
      var $shadeDDOptions = $('.js-shade-select-options', $product);
      var $shadeDDOption = $('.js-shade-select-option', $product);
      var $prevCar = $('.product-full__shades-prev', context);
      var $nextCar = $('.product-full__shades-next', context);
      var $shadeNames = $('.product-full__shade-name', context);

      self.nodes.$shadeNamesSlider = $('.js-product-full__shades-name-slider', context);
      self.nodes.$shadeNameSwatches = $(
        '.js-product-full-shade--filter',
        self.nodes.$shadeNamesSlider
      );
      self.nodes.$prevBtn = $('.js-product-full__shades-name-prev', context);
      self.nodes.$nextBtn = $('.js-product-full__shades-name-next', context);
      var sliderTotalWidth = 0;
      var fullCarouselLength = self.nodes.$shadeNamesSlider.outerWidth(true);
      var isCr21 = Drupal.settings.globals_variables && Drupal.settings.globals_variables.cr21_spp;
      var $omniWrapper = $('.js-product-full-omni-wrapper', context);
      var $smartGift = $('.js-product-smart-gift', context);
      if (isCr21 && $omniWrapper.length > 0 && $smartGift.height() > 0) {
        $('.bopis-spp-container', context).css('margin-bottom', '-18px');
      }

      if ($('[dir=rtl]').length) {
        const $tempCar = $prevCar;
        $prevCar = $nextCar;
        $nextCar = $tempCar;
      }

      $shadeOpenTab.once().on('click', function (event) {
        var $this = $(this);
        var $wrapper = $this.find('.js-shade-select__options-wrapper');
        var $shades = $wrapper.find('.js-shade-select-options');
        var $shade = $shades.find('.js-shade-select-option');
        var shadesCount = $shade?.length || 0;
        var wrapperHeight = 0;

        $this.toggleClass('open');
        wrapperHeight = $shades[0].offsetHeight;

        if (shadesCount < 5) {
          $wrapper.height(wrapperHeight);
        }
      });

      self.nodes.$shadeNameSwatches.each(function () {
        sliderTotalWidth += parseInt($(this).outerWidth(true));
      });
      self.nodes.$shadeNamesSlider.data('innerWidth', sliderTotalWidth);
      if (fullCarouselLength > sliderTotalWidth) {
        self.nodes.$nextBtn.addClass('hidden');
      }

      $(document).click(function (e) {
        if (
          !$(e.target).closest('.js-shade-select-wrapper').length ||
          $(e.target).closest('.js-shade-select-options').length
        ) {
          $shadeOpenTab.removeClass('open');
        }
      });

      Unison.on('change', function () {
        var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
        var bPlargeUp = parseInt(Unison.fetch.all()['usn-large'], 10);

        self.isMobile = currentBpWidth <= bPlargeUp;
        self.initSlickSliderOnShadeNames();
        self.updateArrowVisibility($sppShadesGrid);
        self.setEvents();
      });

      self.nodes.$prevBtn
        .add(self.nodes.$nextBtn)
        .once()
        .on('click', function (event) {
          if (!self.isMobile) {
            return;
          }
          var isShadeNext = $(event.target).hasClass('js-shades-next');
          var shadeSwatchWidth = self.nodes.$shadeNameSwatches.first().width();
          var scrollPosition = isShadeNext ? '+=' + shadeSwatchWidth : '-=' + shadeSwatchWidth;

          self.nodes.$shadeNamesSlider.animate({
            scrollLeft: scrollPosition
          });
        });

      $prevCar
        .add($nextCar)
        .once()
        .on('click', function (event) {
          var isShadeNext = $(event.target).hasClass('js-shades-next');
          var shadeSwatchWidth = isCr21 ? 38 : self.nodes.$shadeSwatches.first().width();
          var scrollPosition = isShadeNext ? '+=' + shadeSwatchWidth : '-=' + shadeSwatchWidth;

          $sppShadesGrid.animate({
            scrollLeft: scrollPosition
          });
        });

      // Only fire on js-product-full-shades for filtering.
      // The small grid sets its own classes and filters.
      $template.each(function () {
        var $shadeGrid = $template.find('.js-product-full-shades-grid');
        var $shadeLink = $shadeGrid.find('.js-spp-shades-grid-item');
        var prevLength;

        if ($shadeGrid.length && $shadeGrid.hasClass('js-product-full-shades-grid--has-filters')) {
          $shadeLink.each(function () {
            var $this = $(this);
            var shadeFam = $this.data('color-family').trim().toLowerCase().replace(/\s+/g, '-');
            var skuBaseId = $this.data('skuBaseId');
            var skuDataL2 = prodcat.data.getSku(skuBaseId);

            if (skuDataL2 && skuDataL2.INVENTORY_STATUS) {
              var invStatus = skuDataL2.INVENTORY_STATUS;

              $this.addClass('shade-inv-status--' + invStatus);
            }

            if (shadeFam.length) {
              $this.addClass('shade-colorfamily--' + shadeFam);
            }
          });

          // Initialize the filter
          $shadeGrid.mixItUp({
            animation: {
              enable: false
            },
            selectors: {
              target: '.js-product-full-shade--filterable',
              filter: '.js-product-full-shade--filter'
            },
            callbacks: {
              onMixEnd: function () {
                var shadeLength = $('.js-product-full-shades-grid > li:visible').length;
                $sppShadesGrid.addClass('mixitup--initialized').mixItUp('setOptions', {
                  animation: {
                    enable: true
                  }
                });
                shadeLength = shadeLength > 15 ? 'full' : shadeLength;
                $shadeGrid
                  .removeClass('products-shade-length-' + prevLength)
                  .addClass('products-shade-length-' + shadeLength);
                prevLength = shadeLength;
              }
            }
          });
        }
      });

      $sppShadesGrid.scroll(
        _.debounce(function () {
          var $this = $(this);
          
          self.updateArrowVisibility($this);
        }, 10)
      );

      // primary listener for shade changes.
      $sppShades.each(function () {
        var $this = $(this);
        var $product = $this.closest('.js-product-full');
        var $shadeLink = $('.js-spp-shades-grid-item', $this);

        $shadeLink.once().on('click', function (e) {
          e.preventDefault();
          var $this = $(this);
          var skuBaseId = parseInt($this.attr('data-sku-base-id'));

          $product
            .trigger('product.skuSelect', [skuBaseId])
            .trigger('product.updateRoute', skuBaseId);
        });
      });

      $shadeNames.each(function () {
        var $this = $(this);
        var shadeName = $this.html();
        var strLen = 20;

        if (shadeName.length > strLen) {
          shadeName = shadeName.substring(0, strLen).trim();
          shadeName += '...';
        }
        $this.html(shadeName);
      });

      $shadeDDOption.on('click', function () {
        $shadeOptionSelected = $(this);
        $shadeOptionSelected.addClass('selected');
        var $select = $(this).attr('data-sku-base-id');
        var $selected = $product.find(
          '.js-spp-shades-grid-item[data-sku-base-id="' + $select + '"]'
        );
        $shadeOptionSelected.trigger('shades-dropdown-selected');
        $selected.trigger('click');

        return;
      });

      $(document).on('product.updateInvStatusFinished', function () {
        var $template = $('.js-product-full-shades', context);
        var $product = $('.js-product-full', context);
        var $shadeDDOptions = $('.js-shade-select-options', $product);

        $template.each(function () {
          var $shadeGrid = $template.find('.js-product-full-shades-grid');
          var items = $shadeGrid.find(
            "[class^='shade-inv-status--'], [class*='shade-inv-status--']"
          );

          if (
            $shadeGrid.length &&
            $shadeGrid.hasClass('js-product-full-shades-grid--has-filters')
          ) {
            items.each(function () {
              var $this = $(this);
              var skuBaseId = $this.data('skuBaseId');
              var skuDataL2 = prodcat.data.getSku(skuBaseId);
              var invStatus;
              var shade_class = $this.attr('class');

              // Search if exist similar class to shade-inv-status-- and remove it to put the new one updated
              if (shade_class.indexOf('shade-inv-status--') >= 0) {
                var currentInvStatusClass = shade_class.match(/[\w-]*shade-inv-status--[\w-]*/g);

                $.each(currentInvStatusClass, function (i, element) {
                  $this.removeClass(element);
                });
              }
              if (skuDataL2 && skuDataL2.INVENTORY_STATUS) {
                invStatus = skuDataL2.INVENTORY_STATUS;
                $this.addClass('shade-inv-status--' + invStatus);

                var $dropdownItem = $shadeDDOptions.find('.js-shade-select-option[data-sku-base-id="' + skuBaseId + '"]');
                if ($dropdownItem.length) {
                  $dropdownItem.attr('data-inventory-status', invStatus);
                }
              }
            });
            sortShadesAndInventory();
            sortDropdownAlphabetically();
          }
        });
      });
    },
    updateArrowVisibility: function ($this) {
      var self = this;
      var $prevCar = $('.product-full__shades-prev', $this.closest('.product-full__shades-grid_wrapper'));
      var $nextCar = $('.product-full__shades-next', $this.closest('.product-full__shades-grid_wrapper'));
      var firstIsVis = self.isScrolledIntoViewHorizontal(
        self.nodes.$shadeSwatches.first(),
        $this
      );
      var lastIsVis = self.isScrolledIntoViewHorizontal(
        self.nodes.$shadeSwatches.last(),
        $this
      );
      var minShadeCount = 7;
      var arrowDisableClass = 'disabled';

      // If there are less than 7 shades hide the arrows
      if (self.nodes.$shadeSwatches.length <= minShadeCount) {
        $nextCar.addClass('hidden');
      } else {
        $prevCar.toggleClass(arrowDisableClass, firstIsVis);
        $nextCar.toggleClass(arrowDisableClass, lastIsVis);
      }
    },
    isScrolledIntoViewHorizontal: function ($el, $container) {

      if (!$el?.length) {
        return;
      }

      const elemLeft = $el.offset().left;
      const elemOuterWidth = $el.outerWidth(true);
      const elemRight = elemLeft + elemOuterWidth;
      const containerLeft = $container.offset().left;
      const visibleSlideCount = $container.innerWidth();
      const containerRight = containerLeft + visibleSlideCount;

      // Partially visible elements return true:
      return (elemRight > containerLeft && elemLeft < containerRight);
    },
    initSlickSliderOnShadeNames: function () {
      var self = this;

      if (self.isMobile) {
        return;
      }
      self.nodes.$shadeNamesSlider.each(function () {
        var $this = $(this);
        var settings = {
          dots: false,
          infinite: false,
          variableWidth: true,
          slidesToShow: 5,
          slidesToScroll: 1,
          onInit: function () {
            var fullCarouselWidth = $this.find('.slick-track').outerWidth(true);

            if (fullCarouselWidth <= $this.outerWidth(true)) {
              $this.find('.slick-next').addClass('hidden');
            }
          },
          onAfterChange: function (slide, index) {
            var $shadeNameNext = $('.slick-next', $this);
            var slider_length = $this.find('.slick-track > div').length - 1;

            $shadeNameNext.removeClass('hidden');
            if (parseInt(slider_length / 2) === index) {
              $shadeNameNext.addClass('hidden');
            }
          }
        };

        $this.slick(settings);
      });
    },
    setEvents: function () {
      var self = this;

      self.nodes.$shadeNamesSlider.scroll(
        _.debounce(function () {
          if (!self.isMobile) {
            return;
          }
          var $this = $(this);
          var firstIsVis = self.isScrolledIntoViewHorizontal(
            self.nodes.$shadeNameSwatches.first(),
            $this
          );
          var lastIsVis = self.isScrolledIntoViewHorizontal(
            self.nodes.$shadeNameSwatches.last(),
            $this
          );

          // if there are less than 7 shades hide the arrows
          if ($this.data('innerWidth') === $this.outerWidth(true)) {
            self.nodes.$nextBtn.addClass('hidden');
          } else {
            if (firstIsVis && !lastIsVis) {
              // hide prev. arrow
              self.nodes.$prevBtn.addClass('hidden');
              self.nodes.$nextBtn.removeClass('hidden');
            }
            if (!firstIsVis && !lastIsVis) {
              // display both arrows
              self.nodes.$nextBtn.removeClass('hidden');
              self.nodes.$prevBtn.removeClass('hidden');
            }
            if ((lastIsVis && !firstIsVis) || (lastIsVis && firstIsVis)) {
              // hide next arrow
              self.nodes.$nextBtn.addClass('hidden');
              self.nodes.$prevBtn.removeClass('hidden');
            }
          }
        }, 10)
      );
    },
    attached: false
  };
  const filterOutBundleItems = function ($items) {
    return $items.filter(function () {
      return $(this).closest('.js-pdp-bundle-item').length < 1;
    });
  };
  // shade picker listener
  $(document).on('product.skuSelect', '.js-product-full', function (e, skuBaseId) {
    var $product = $(this);
    var $shadeInfoName = filterOutBundleItems($('.product-full__shade-info-name', $product));
    var $shadeInfoDesc = filterOutBundleItems($('.product-full__shade-info-description', $product));
    var $shadeSkuBadge = $('.js-product-full__sku-badge', $product);
    var $shadesGrid = $('.js-spp-shades-grid', $product);
    var $selectedShade = $product.find(
      '.js-spp-shades-grid-item[data-sku-base-id="' + skuBaseId + '"]'
    );
    if ($selectedShade.length < 1) {
      // If the shade grid is not loaded on the PDP
      // no need to parse the code.
      return;
    }
    var $shadeLabelText = filterOutBundleItems($('.js-shade-select-label-text', $product));
    var $shadeLabelColor = filterOutBundleItems($('.js-shade-select-label-color', $product));
    var $productSize = filterOutBundleItems($('.js-product-full-size', $product));
    var shadeHex = $selectedShade.data('hex');
    var shadeName = $selectedShade.data('shade-name');
    var shadeDesc = $selectedShade.data('shade-desc');
    var skuFlagText = $selectedShade.data('misc-flag-text');
    var shaded = $('.js-product-full__image', $product).attr('data-is-shaded');
    var textFields = [
      {
        selector: 'js-product-full-sku-notes',
        field: 'SKU_NOTES'
      }
    ];
    var skuData = prodcat.data.getSku(skuBaseId);
    var ingredients = skuData ? skuData.ILN_LISTING : '';
    var ilnNumber = skuData ? skuData.ILN_NUMBER : '';
    var expirationDate = skuData ? skuData.EXPIRATION_DATE : '';
    var isCr21 = Drupal.settings.globals_variables && Drupal.settings.globals_variables.cr21_spp;
    var $ilnListContainer = $('.js-product-full-iln-listing');
    var $ilnListTag = $('<p class="js-product-full-iln-listing" />');
    var $ilnNumberContainer = $('.js-product-full-iln-number');
    var $ilnNumberTag = $('<span class="js-product-full-iln-number" />');

    if (expirationDate) {
      $('.js-sku-expiration-date').html(
        site.translations.product.expiration_date_label + ': ' + expirationDate
      );
      $('.js-sku-use-by').html(site.translations.product.use_by);
    } else {
      $('.js-sku-expiration-date').empty();
      $('.js-sku-use-by').empty();
    }

    if (ingredients) {
      $product.find('.js-product-full-ingredients-title').show();
      $product.find('.js-product-full-ingredients-content').show();
      if ($ilnListContainer.length) {
        $ilnListContainer.html(ingredients);
        $ilnNumberContainer.text('<' + ilnNumber + '>');
      } else {
        $ilnListTag.html(ingredients);
        $ilnNumberTag.text('<' + ilnNumber + '>');
        $('.js-product-full-ingredients-content').append($ilnListTag, $ilnNumberTag);
      }
    } else {
      $product.find('.js-product-full-ingredients-title').hide();
      $product.find('.js-product-full-ingredients-content').hide();
    }

    $product.attr('data-sku-base-id', skuBaseId);
    $product.find('.js-spp-shades-grid-item').removeClass('active');
    $selectedShade.addClass('active');
    $shadeInfoName.html(shadeName);
    $shadeInfoName.attr('data-hex', shadeHex);
    $shadeLabelColor.css('background-color', shadeHex);
    $shadeLabelText.html(shadeName);
    $shadeInfoDesc.html(shadeDesc);
    $shadeSkuBadge.html(skuFlagText);
    _.each(textFields, function (el) {
      var $el = $('.' + el.selector, $product);

      if ($el.length < 1) {
        return;
      }
      $el.html(skuData[el.field]);
    });

    if (shaded === 'true') {
      $(window).on('load', function () {
        var scrolltoLeft = 0;
        var scrolltoTop = 0;

        scrolltoLeft += $selectedShade.offset().left;
        scrolltoLeft -= $selectedShade.outerWidth(true) / 2;
        scrolltoTop += $selectedShade.offset().top;
        scrolltoTop -= $shadesGrid.offset().top;
        scrolltoLeft = isCr21
          ? $('.js-product-full-shades-grid').find('.active').index() * 38
          : scrolltoLeft;
        $shadesGrid.animate(
          {
            scrollLeft: scrolltoLeft,
            scrollTop: scrolltoTop
          },
          350
        );
      });
    }

    // Change product size
    if (!!skuData?.PRODUCT_SIZE) {
      $productSize.text(skuData.PRODUCT_SIZE);
    }
    if ($selectedShade.hasClass('low-contrast')) {
      $selectedShade
        .closest('.js-product-full__tabbed-content')
        .find('.js-shade-select')
        .addClass('low-contrast');
    } else {
      $selectedShade
        .closest('.js-product-full__tabbed-content')
        .find('.js-shade-select')
        .removeClass('low-contrast');
    }
  });
})(jQuery, window.prodcat || {});
